// Capture coordinates before any asynchronous work. Never infer rewards from clicks.
let source = null;
const listeners = new Set();
export const snapshotRect = el => {
  const r = el?.getBoundingClientRect?.();
  return r && r.width > 0 && r.height > 0 ? { x:r.x, y:r.y, width:r.width, height:r.height } : null;
};
export function captureRewardSource(event) {
  const el = event.submitter || event.target?.closest?.('button, [role="button"], input[type="submit"]');
  const rect = snapshotRect(el);
  if (rect) source = { rect, element:typeof WeakRef!=='undefined'?new WeakRef(el):null, route:window.location.pathname, at:Date.now() };
}
export function rewardRequest(config, preview) {
  if (preview || !source || Date.now()-source.at > 3000 || /\/(auth|admin|gamification)\//.test(config.url || '') ||
      ['get','head','options'].includes(config.method || 'get')) return null;
  return { ...source, element:source.element?.deref?.(), id: globalThis.crypto?.randomUUID?.() || `reward-${Date.now()}-${Math.random().toString(36).slice(2)}`,
    undo:config.url === '/undo', started:Date.now() };
}
export function rewardConfirmed(request) { if (request) listeners.forEach(fn=>fn({...request,state:"confirmed"})); }
export function rewardStarted(request) { if(request)listeners.forEach(fn=>fn({...request,state:"started"})); }
export function rewardFailed(request) { if(request)listeners.forEach(fn=>fn({...request,state:"failed"})); }
export function subscribeRewards(fn) { listeners.add(fn); return ()=>listeners.delete(fn); }
export function clearRewardSource() { source=null; }
export function reverseDestination(item, origin, request, route, target) {
  if (item.kind !== 'undo') return target;
  if (origin && origin.route===route && Date.now()-origin.at<120000 && (!origin.element || origin.element.deref?.()?.isConnected)) return origin.rect;
  return request?.rect || target;
}
export function rewardStrength(action) {
  if(action==='closed_won')return 18;
  if(action==='offer_completed')return 14;
  if(action==='potential_created')return 12;
  if(action.startsWith('call_'))return 6;
  return 10;
}
